module.exports = __webpack_public_path__ + "media/src/assets/images/calendar_grey@2x-41708957ff83fa68d6ef23ab132b9d17.png";